import { useQuery } from '@tanstack/react-query';

import { RECOMMENDED_LEAGUES_QUERY_KEY } from '@/hooks/constants';
import { getRecommendedLeagues } from '@/infrastructure/network/data/homepage/team-leagues';

export const useGetRecommendedLeaguesQuery = () => {
	return useQuery({
		queryKey: [RECOMMENDED_LEAGUES_QUERY_KEY],
		queryFn: () => getRecommendedLeagues()
	});
};
